/**
 * @generated SignedSource<<ae09931880084ab2bce47abf95d3e231>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReportType = "ALL" | "DETAILED_SKILL" | "DIAGNOSTIC_SUMMARY" | "SKILL_ASSESSMENT_HISTORY" | "STUDENTS_WITH_UNFINISHED_DIAGNOSTICS" | "%future added value";
export type PresignedUrlsForReportExamplesFilterInput = {
  reportType: ReportType;
};
export type ReportHubViewExamplePresignedUrlQuery$variables = {
  filter: PresignedUrlsForReportExamplesFilterInput;
};
export type ReportHubViewExamplePresignedUrlQuery$data = {
  readonly presignedURLsForReportExamples: {
    readonly detailedSkillReportExampleUrl: string | null | undefined;
    readonly diagnosticSummaryReportExampleUrl: string | null | undefined;
    readonly skillAssessmentHistoryReportExampleUrl: string | null | undefined;
    readonly unfinishedDiagnosticsReportExampleUrl: string | null | undefined;
  };
};
export type ReportHubViewExamplePresignedUrlQuery = {
  response: ReportHubViewExamplePresignedUrlQuery$data;
  variables: ReportHubViewExamplePresignedUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "ReportExamplePresignedUrls",
    "kind": "LinkedField",
    "name": "presignedURLsForReportExamples",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unfinishedDiagnosticsReportExampleUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skillAssessmentHistoryReportExampleUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "diagnosticSummaryReportExampleUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "detailedSkillReportExampleUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportHubViewExamplePresignedUrlQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportHubViewExamplePresignedUrlQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a7a32eaae8ee2cdf09998a162561bd41",
    "id": null,
    "metadata": {},
    "name": "ReportHubViewExamplePresignedUrlQuery",
    "operationKind": "query",
    "text": "query ReportHubViewExamplePresignedUrlQuery(\n  $filter: PresignedUrlsForReportExamplesFilterInput!\n) {\n  presignedURLsForReportExamples(filter: $filter) {\n    unfinishedDiagnosticsReportExampleUrl\n    skillAssessmentHistoryReportExampleUrl\n    diagnosticSummaryReportExampleUrl\n    detailedSkillReportExampleUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e2b4271f87bd0247d77152d78659b56";

export default node;
